module.exports = __webpack_public_path__ + "img/menu_ic_lucky.ef94eb44.png";